import { Profile_Type, type ActivityFragment } from "@/graphql/generated-types";
import type { ParticipantData } from "@/types";

const toParticipantsData = (data: ActivityFragment): ParticipantData => {
  const participants = data.participants || [];
  const responsible = data.responsible || [];

  return {
    employeesResponsible: responsible
      .filter((item) => item.type === Profile_Type.Employee)
      .map((item) => item.id)
      .toSorted(),

    employeesSignedUp: participants
      .filter((item) => item.__typename === "Employee")
      .map((item) => item.id)
      .toSorted(),

    residentsResponsible: responsible
      .filter((item) => item.__typename === "Resident")
      .map((item) => item.id)
      .toSorted(),

    residentsSignedUp: participants
      .filter((item) => item.__typename === "Resident")
      .map((item) => item.id)
      .toSorted(),
  };
};

export default {
  toParticipantsData,
};
